<div class="d-flex justify-content-center text-center flex-column">
    <div>
      <mat-icon *ngIf="data.code !== 412 || data.code === 400" style="font-size: 2rem; color: #b20000">error_outline</mat-icon>
      <mat-icon *ngIf="data.code === 412" style="font-size: 2rem; color: #1a59a8">info_outline</mat-icon>
    </div>
    <p>{{ data.message }}</p>
    <button class="btn btn-ouitline" mat-button (click)="closeDialog()">Cerrar</button>
</div>
